import React from 'react';
import './inproduction.css';
import { useNavigate } from 'react-router-dom';

const InProduction = () => {
  const navigate = useNavigate();

  return (
    <>
      <h1>In Production</h1>
      <div className="production-steps">
        <div className="step">
          <div className="step-header">
            <div className="step-icon">🎙️</div>
            <div className="step-title">STEP 1: TALENT REQUESTS IN PRODUCTION</div>
          </div>
          <div className="step-content">
            <p>No Talent Requests are in production right now.</p>
            <p>To make a request for custom messaging or advertising, please visit the <span className="link" onClick={() => navigate('/master-account/talent-request')}>Talent Requests</span> page.</p>
          </div>
        </div>

        <div className="step">
          <div className="step-header">
            <div className="step-icon">✓</div>
            <div className="step-title">STEP 2: AWAITING APPROVAL</div>
          </div>
          <div className="step-content">
            <p>No Talent Requests to approve right now.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default InProduction; 